import axios, { AxiosInstance } from 'axios';
import { HttpClient, HttpResponse } from 'core/base/HttpClient';
import { Authentication, ErrorHandler } from 'infraestructure/middlewares';

export class AxiosHttpClient implements HttpClient {
  private static _axios: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    params: {
      pais: process.env.REACT_APP_COUNTRY_CODE || 'gt'
    }
  });

  private static _instance?: AxiosHttpClient;
  protected client: AxiosInstance;

  private constructor() {
    this.client = AxiosHttpClient._axios;
    this.configureInterceptors();
  }

  private configureInterceptors() {
    this.client.interceptors.request.use(Authentication);
    this.client.interceptors.response.use(undefined, ErrorHandler);
  }

  static instance(): HttpClient {
    if (!this._instance) {
      this._instance = new AxiosHttpClient();
    }
    return this._instance;
  }

  get = async (
    url: string,
    params?: Record<string, unknown>
  ): Promise<HttpResponse> => {
    return await this.client.get(url, { params });
  };

  post = async (
    url: string,
    data: unknown
  ): Promise<HttpResponse> => {
    return await this.client.post(url, data);
  };

  put = async (
    url: string,
    data: unknown
  ): Promise<HttpResponse> => {
    return await this.client.put(url, data);
  };

  delete = async (url: string): Promise<HttpResponse> => {
    return await this.client.delete(url);
  };
}

export default AxiosHttpClient;
